import React from "react";
import SearchBar from "../components/SearchBar";
import HeroSection from "../components/HeroSection";
import StepSection from "../components/StepSection";
import FaqSection from "../components/FaqSection";
import BrandLogoSection from "../components/BrandLogoSection";
import Footer from "../../../components/layout/Footer";
import RecommendedProducts from "../components/RecommendedProducts";

type Props = {
  keyword: string;
  setKeyword: React.Dispatch<React.SetStateAction<string>>;
};

export default function SearchEntryScreen({
  keyword,
  setKeyword,
}: Props) {
  return (
    <div className="w-full">
      {/* ヒーローセクション */}
      <HeroSection />

      {/* 検索バー */}
      <section className="bg-white py-10">
        <SearchBar keyword={keyword} setKeyword={setKeyword} />
      </section>

      {/* 使い方ステップ */}
      <StepSection />

      {/* おすすめ商品 */}
      <RecommendedProducts />

      {/* FAQ */}
      <FaqSection />

      {/* ロゴ */}
      <BrandLogoSection />
      <Footer />
    </div>
  );
}
